import "./Checkbox.css";

export function Checkbox({ label, checked = false, id, setIsActive, disabled = false }){
  return (
    <div className={`checkbox ${disabled ? "checkbox-disabled" : ""}`}>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={() => setIsActive(!checked)}
        className="form-check-input"
        disabled = {disabled}
      />
      <label htmlFor={id} style={{ marginLeft: "5px" }}>
        {label}
      </label>
    </div>
  );
};
